// =============================================================================
// reducers/lookupReducer.js
//
// State for the lookups that feed the dropdowns. Loaded once per session
// (only changes when there are new rules, vendors, etc.).
//
// IMPORTANT: add to the rootReducer:
//   import lookupReducer from './lookupReducer';
//   combineReducers({ ..., lookups: lookupReducer });
// =============================================================================
import {
	LOOKUPS_FETCH_REQUEST, LOOKUPS_FETCH_SUCCESS, LOOKUPS_FETCH_FAILURE,
} from '../constants/kpiConstants';

const initialState = {
	loading:    false,
	error:      null,
	loaded:     false,

	vendors:    [],
	techs:      [],
	kpis:       [],
	severities: [],
	statuses:   [],
};

export default function lookupReducer(state, action) {
	if (state === undefined) state = initialState;

	switch (action.type) {
		case LOOKUPS_FETCH_REQUEST:
			return Object.assign({}, state, { loading: true, error: null });

		case LOOKUPS_FETCH_SUCCESS: {
			const p = action.payload || {};
			return Object.assign({}, state, {
				loading:    false,
				loaded:     true,
				vendors:    p.vendors    || [],
				techs:      p.techs      || [],
				kpis:       p.kpis       || [],
				severities: p.severities || [],
				statuses:   p.statuses   || [],
			});
		}

		case LOOKUPS_FETCH_FAILURE:
			return Object.assign({}, state, { loading: false, error: action.payload });

		default:
			return state;
	}
}
